import { Component, EventEmitter, Input, isDevMode, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { I4goPaymentRequestDTO, I4goPaymentResponseDTO } from '../../models/DTO/I4goPaymentRequest.dto';

declare var DatacapWebToken: any;
declare var require: any;

@Component({
	selector: 'app-datacap-payment',
	templateUrl: './datacap-payment.component.html',
	styleUrls: ['../../../modules/online-order/online-order.component.scss'],
})
export class DatacapPaymentComponent implements OnInit {
	@Input() datacapApiSecret: string;
	@Input() i4goPaymentRequestDTO: I4goPaymentRequestDTO;
	@Input() transactionAmount: number;

	@Output() i4goPaymentResponseDTOChange = new EventEmitter<I4goPaymentResponseDTO>();

	payApiPaymentRequest: PayAPIPaymentRequest = new PayAPIPaymentRequest();
	processing: boolean = false;

	creditCardProperties = {
		iconGroup: 'far',
		icon: 'credit-card-front',
		type: undefined,
		mask: '9999-9999-9999-9999',
		valid: false,
		status: undefined,
	};

	tokenCallback = function (response) {
		if (response.Error) {
			alert('Token error: ' + response.Error);
		} else {
			var token = response.Token;
			const datacapResponse = new DatacapTokenResponse(response);

			this.paymentResponse(
				datacapResponse.Token,
				datacapResponse.ExpirationMonth,
				datacapResponse.ExpirationYear,
				this.payApiPaymentRequest.cvv,
				datacapResponse.Last4
			);
		}
	};

	constructor(public app: AppService) {}

	ngOnInit(): void {
		if (isDevMode() && !this.datacapApiSecret) {
			this.datacapApiSecret = '42ade27b2ab744209e29c396d8cd724c';
		}
	}

	cardLength() {
		// add 2 (amex) or 3 (others) characters to account for spaces in the form input
		if (this.creditCardProperties.type === 'american-express') {
			return 17;
		}
		return 19;
	}

	evalCCInput(value: string) {
		var creditCardType = require('credit-card-type');
		const creditCardTypeValue = creditCardType(value);
		if (creditCardTypeValue.length === 1) {
			this.creditCardProperties.iconGroup = 'fab';
			this.creditCardProperties.mask = '9999-9999-9999-9999';
			this.creditCardProperties.type = creditCardTypeValue[0].type;
			switch (creditCardTypeValue[0].type) {
				case 'visa':
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.icon = 'cc-visa';

					break;
				case 'mastercard':
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.icon = 'cc-mastercard';
					break;
				case 'discover':
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.icon = 'cc-discover';
					break;
				case 'american-express':
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.icon = 'cc-amex';
					this.creditCardProperties.mask = '99999-99999-99999';
					break;
				case 'diners':
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.icon = 'cc-diners-club';
					break;
				case 'jcb':
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.icon = 'cc-jcb';
					break;
				default:
					this.app.devLog(`set ${creditCardTypeValue[0].type}`);
					this.creditCardProperties.iconGroup = 'far';
					this.creditCardProperties.icon = 'credit-card-front';
					break;
			}
		} else {
			this.creditCardProperties.iconGroup = 'far';
			this.creditCardProperties.icon = 'credit-card-front';
			this.creditCardProperties.mask = '9999-9999-9999-9999';
		}
		value = value.replace(/-/g, '');
		value = value.replace(/ /g, '');
		let validatedInput = DatacapWebToken.validateCardNumber(value);
		validatedInput === validatedInput ? true : false;
		this.creditCardProperties.valid = validatedInput;
		if (!validatedInput) {
			if (this.creditCardProperties.type === 'american-express' && value.length === 15) {
				this.creditCardProperties.status = 'credit card number invalid';
			}
			if (this.creditCardProperties.type !== 'american-express' && value.length === 16) {
				this.creditCardProperties.status = 'credit card number invalid';
			}
		} else {
			this.app.devLog(`Valid: ${validatedInput}`);
			this.creditCardProperties.status = undefined;
		}
	}

	evalForm() {
		if (this.creditCardProperties.valid) {
			if (
				this.app
					.moment(`${this.payApiPaymentRequest.expirationMonth}/${this.payApiPaymentRequest.expirationYear}`, 'MM/YYYY')
					.isAfter(this.app.moment())
			) {
				if (
					(this.creditCardProperties.type === 'american-express' && this.payApiPaymentRequest.cvv?.length === 4) ||
					(this.creditCardProperties.type !== 'american-express' && this.payApiPaymentRequest.cvv?.length === 3)
				) {
					if (this.payApiPaymentRequest.postalCode?.length === 5) {
						this.payApiPaymentRequest.validInput = true;
						return false;
					}
				}
			}
		}
		this.payApiPaymentRequest.validInput = false;
		return true;
	}

	paymentResponse(token: string, expirationMonth: string, expirationYear: string, cvv: string, lastFour: string) {
		this.payApiPaymentRequest.displayCardNumber = this.cardLength() === 17 ? lastFour.padStart(15, 'X') : lastFour.padStart(16, 'X');
		this.i4goPaymentResponseDTOChange.emit(
			new I4goPaymentResponseDTO({
				amount: this.transactionAmount,
				token: token,
				expirationMonth: expirationMonth,
				expirationYear: expirationYear,
				securityCode: this.payApiPaymentRequest.cvv,
				postalCode: this.payApiPaymentRequest.postalCode,
				displayName: this.cardLength() === 17 ? lastFour.padStart(15, 'X') : lastFour.padStart(16, 'X'),
				streetAddress: this.i4goPaymentRequestDTO?.billing?.street,
			})
		);
	}

	submit() {
		this.processing = true;
		this.payApiPaymentRequest.cardNumber = this.payApiPaymentRequest.displayCardNumber;
		this.payApiPaymentRequest.cardNumber = this.payApiPaymentRequest.cardNumber.replace(/-/g, '');
		this.payApiPaymentRequest.cardNumber = this.payApiPaymentRequest.cardNumber.replace(/ /g, '');
		this.payApiPaymentRequest.displayCardNumber = this.payApiPaymentRequest.cardNumber;

		try {
			this.app.loading(true);
			DatacapWebToken.requestToken(this.datacapApiSecret, 'payment_form', (response) => {
				if (response.Error) {
					alert('Token error: ' + response.Error);
				} else {
					var token = response.Token;
					const datacapResponse = new DatacapTokenResponse(response);

					this.paymentResponse(
						datacapResponse.Token,
						datacapResponse.ExpirationMonth,
						datacapResponse.ExpirationYear,
						this.payApiPaymentRequest.cvv,
						datacapResponse.Last4
					);
				}
			});
		} catch (error) {}
	}

	validateCardNumber(val) {
		return DatacapWebToken.validateCardNumber(val);
	}

	validateCvv(val) {
		return DatacapWebToken.validateCVV(val);
	}

	validateExp(monthVal, yearVal) {
		return DatacapWebToken;
	}
}

class PayAPIPaymentRequest {
	cardNumber: string;
	displayCardNumber: string;
	expirationMonth: string;
	expirationYear: string;
	cvv: string;
	postalCode: string;
	validInput: boolean;
	token: string;

	public constructor(init?: Partial<PayAPIPaymentRequest>) {
		Object.assign(this, init);
	}
}

class DatacapTokenResponse {
	Bin: string;
	Brand: string;
	ExpirationMonth: string;
	ExpirationYear: string;
	Last4: string;
	Token: string;

	public constructor(init?: Partial<DatacapTokenResponse>) {
		Object.assign(this, init);
	}
}
